import pkgCode from '@/utils/pkgCode'
import router from '@/router'
import store from '@/store'
import { downloadImageCrossPlatform, sendShakeDataFun } from "@/utils/file";
import JHSDK from '../../public/SDK/JHSDK.min.3.20.3'
class ArmcloudEngine {
    // 容器id
    viewId = "phoneBoxId"
    // rtc实例
    rtcInstance = null
    // rtc初始化参数
    rtcOptions = null
    // 默认清晰度
    odefinitionObj = {
        id: 2,
        width: 720,
        height: 1280,
        bitrate: 4096,
        fps: 30,
    }
    channelType = {}
    callbacks = null
    userdata = {}
    channelCode = ""
    instanceCode = ""
    constructor(params) {
        this.userdata = JSON.parse(store.getters.data)
        let findOdefinition = pkgCode.odefinitionOptions.find(
            (item) => item.id == params.odefinition
        );
        this.channelCode = params.channelCode
        this.instanceCode = params.instanceCode
        if (findOdefinition) this.odefinitionObj = findOdefinition
        if (this.channelCode == "baidu") {
            this.callbacks = {
                // 初始化回调
                onInit: params.callbacks?.onInit || (() => { }),
                // 运行信息回调
                onRunInformation: params.callbacks?.onRunInformation || (() => { }),
                // 连接成功回调
                onConnectSuccess: params.callbacks?.onConnectSuccess || (() => { }),
                // 连接失败回调
                onConnectFail: params.callbacks?.onConnectFail || (() => { }),
                // 播放异常回调
                onErrorMessage: params.callbacks?.onErrorMessage || (() => { }),
                // 云手机复制字符串回调
                onOutputClipper: params.callbacks?.onOutputClipper || (() => { }),
                onRotation: params.callbacks?.onRotation || (() => { }),
            }
            this.rtcOptions = {
                deviceInfo: JSON.parse(params.serverToken),
                viewId: this.viewId,
                uuid: "205",
                width: this.odefinitionObj.width,
                height: this.odefinitionObj.height,
                bitrate: this.odefinitionObj.bitrate,
                fps: this.odefinitionObj.fps,
                isCameraLive: this.userdata.isCamera == "1",
                isMicrophoneLive: this.userdata.isVoice == "1",
                callbacks: this.callbacks
            };
            try {
                let initRet = new redfingerV2.init(this.rtcOptions);
                if (initRet) {
                    this.rtcInstance = redfingerV2
                    this.rtcInstance.start();
                }
            } catch (error) {
                console.log(error);
            }
        }
        if (this.channelCode == "intelligent") {
            this.rtcInstance = new NzCp();
            this.rtcOptions = {
                userId: params.hsServerTokenVo.uuid || this.userdata?.uuid,
                mountId: this.viewId,
                instanceNo: params.instanceCode,
                streamType: 2,
                width: this.odefinitionObj.width,
                height: this.odefinitionObj.height,
                bitrate: this.odefinitionObj.bitrate,
                fps: this.odefinitionObj.fps,
                isMute: this.userdata?.isVoice == 0,
            };
            this.callbacks = {
                // 初始化成功回调
                onInitSuccess: params.callbacks?.onInitSuccess || (() => { }),
                // 初始化失败回调
                onInitFail: params.callbacks?.onInitFail || (() => { }),
                // 运行信息回调
                onPlayInfo: params.callbacks?.onPlayInfo || (() => { }),
                // 连接成功回调
                onStartSuccess: params.callbacks?.onStartSuccess || (() => { }),
                // 连接失败回调
                onStartFail: params.callbacks?.onStartFail || (() => { }),
                // 播放异常回调
                onError: params.callbacks?.onError || (() => { }),
                // 云手机复制字符串回调
                onOutClipperChange: params.callbacks?.onOutClipperChange || (() => { }),
                onRotationChange: params.callbacks?.onRotationChange || (() => { }),
            }
            let initRet = this.rtcInstance.init(this.rtcOptions, this.callbacks);
            if (!initRet) {
                return;
            }
            this.rtcInstance.start(
                params.hsServerTokenVo.ak,
                params.hsServerTokenVo.sk
            );
        }
        if (this.channelCode == "huawei") {
            this.callbacks = {
                // 初始化成功回调
                onInitSuccess: params.callbacks?.onInitSuccess || (() => { }),
                // 画面第一帧回调
                onRenderedFirstFrame: params.callbacks?.onRenderedFirstFrame || (() => { }),
                // 初始化失败回调
                onInitFail: params.callbacks?.onInitFail || (() => { }),
                // 运行信息回调
                netStateChange: params.callbacks?.netStateChange || (() => { }),
                // 连接成功回调
                onConnectSuccess: params.callbacks?.onConnectSuccess || (() => { }),
                // 连接失败回调
                onConnectFail: params.callbacks?.onConnectFail || (() => { }),
                // 云手机复制字符串回调
                clipboardDataChange: params.callbacks?.clipboardDataChange || (() => { }),
                // 连接终止回调
                onStoped: params.callbacks?.onStoped || (() => { }),
                // 屏幕方向回调
                onRotatePlayer: params.callbacks?.onRotatePlayer || (() => { }),

            }
            this.rtcOptions = {
                serverToken: params.token, // 会话标识
                libPath: window.location.origin + "/lib/", // 项目根目录
                linkMethod: "1",
                protocol: "wss", // 云手机连接服务协议(默认wss)
                connectURI: params.traceServer, // 云手机连接地址(默认demo.jinhaokj.com.cn/sdk-ws)
                callbacks: this.callbacks
            }
            this.rtcInstance = new JHSDK(this.rtcOptions);
            // 启动云手机并开始展示云手机相关画面
            let connectInfo = {
                accessIp: params["controlIp"],
                accessPort: Number(params["controlPort"]),
                phoneId: params["instanceCode"],
                sessionId: params["sessionId"],
                timestamp: params["createAt"],
                ticket: params["serverToken"],
                media_config: {
                    mute: this.userdata.isVoice == 0 ? 1 : 0,
                    quality: params.odefinition == 0 ? "basic" : params.odefinition == 1 ? "main" : "best",
                },
                isAutoRotate: false,
                keepRatio: true,
                serverToken: params.token
            };
            
            this.rtcInstance.startPhone(this.viewId, connectInfo);
        }
    }
    /** 底部栏操作按键 */
    sendCommand(type) {
        if (this.rtcInstance) {
            if (this.channelCode == "baidu") {
                if (type == "zhuomian")
                    this.rtcInstance.sendCommand(redfinger.KEY_TYPE.KEY_HOMEPAGE)
                if (type == "home")
                    this.rtcInstance.sendCommand(redfinger.KEY_TYPE.KEY_MENU)
                if (type == "fanhui")
                    this.rtcInstance.sendCommand(redfinger.KEY_TYPE.KEY_BACK)
            }
            if (this.channelCode == "intelligent") {
                if (type == "zhuomian")
                    this.rtcInstance.home();
                if (type == "home")
                    this.rtcInstance.menu();
                if (type == "fanhui")
                    this.rtcInstance.back();
            }
            if (this.channelCode == "huawei") {
                if (type == "zhuomian")
                    this.rtcInstance['home'](this.instanceCode);
                if (type == "home")
                    this.rtcInstance['menu'](this.instanceCode);
                if (type == "fanhui")
                    this.rtcInstance['back'](this.instanceCode);
            }
        }
    }
    /**加减音量 */
    volumeControl(type) {
        if (this.rtcInstance) {
            if (this.channelCode == "baidu") {
                if (type == "add")
                    this.rtcInstance.sendCommand(keyboard.androidkey.KEY_VOLUMEUP)
                if (type == "subtract")
                    this.rtcInstance.sendCommand(keyboard.androidkey.KEY_VOLUMEDOWN)
            }
            if (this.channelCode == "intelligent") {
                if (type == "add")
                    this.rtcInstance.setVolumeUp()
                if (type == "subtract")
                    this.rtcInstance.setVolumeDown()
            }
            if (this.channelCode == "huawei") {
                if (type == "add")
                    this.rtcInstance.volumeUp([this.instanceCode])
                if (type == "subtract")
                    this.rtcInstance.volumeDown([this.instanceCode])
            }
        }
    }
    /**切换清晰度 */
    cutOdefinition(type) {
        return new Promise((resolve, reject) => {
            if (this.rtcInstance) {
                if (this.channelCode == "baidu") {
                    try {
                        if (type == 0)
                            this.rtcInstance.setStreamConfig(432, 768, 1024, 20);
                        resolve({ code: 200, data: type })
                        if (type == 1)
                            this.rtcInstance.setStreamConfig(576, 1024, 2048, 30)
                        resolve({ code: 200, data: type })
                        if (type == 2)
                            this.rtcInstance.setStreamConfig(720, 1280, 4096, 30)
                        resolve({ code: 200, data: type })
                    } catch (error) {
                        reject(error)
                    }
                }
                if (this.channelCode == "intelligent") {
                    try {
                        if (type == 0)
                            this.rtcInstance.setStreamProfile({
                                width: 432,
                                height: 768,
                                fps: 20,
                                bitrate: 1024,
                            });
                        resolve({ code: 200, data: type })
                        if (type == 1)
                            this.rtcInstance.setStreamProfile({
                                width: 576,
                                height: 1024,
                                fps: 30,
                                bitrate: 2048,
                            });
                        resolve({ code: 200, data: type })
                        if (type == 2)
                            this.rtcInstance.setStreamProfile({
                                width: 720,
                                height: 1280,
                                fps: 30,
                                bitrate: 4096,
                            });
                        resolve({ code: 200, data: type })
                    } catch (error) {
                        reject(error)
                    }
                }
                if (this.channelCode == "huawei") {
                    try {
                        if (type == 0)
                            this.rtcInstance.setStreamConfig({
                                quality: "basic",
                            });
                        resolve({ code: 200, data: type })
                        if (type == 1)
                            this.rtcInstance.setStreamConfig({
                                quality: "main",
                            });
                        resolve({ code: 200, data: type })
                        if (type == 2)
                            this.rtcInstance.setStreamConfig({
                                quality: "best",
                            });
                        resolve({ code: 200, data: type })
                    } catch (error) {
                        reject(error)
                    }
                }

            }
        })
    }
    // 切换设备
    cutCloudPhone(code) {
        return new Promise((resolve, reject) => {
            try {
                router.replace({
                    path: "/cloudPhone",
                    query: { instanceCode: code },
                }).then(() => {
                    resolve()
                });
            } catch (error) {
                reject(error)
            }
        })
    }
    // 销毁实例
    destroyedInstance() {
        if (this.rtcInstance) {
            if (this.channelCode == "baidu") this.rtcInstance.stop()
            if (this.channelCode == "intelligent") this.rtcInstance.destroy()
            if (this.channelCode == "huawei") {
                this.rtcInstance.stopPhone([this.instanceCode])
                var element = document.getElementById(this.viewId);
                if (element) {
                    element.replaceChildren();
                }
            }
        }
    }
    // 刷新
    refreshCloudPhone() {
        router.go(0)
    }
    // 退出
    quitCloudPhone() {
        if (this.rtcInstance) {
            if (this.channelCode == "baidu") {
                this.rtcInstance.stop().then(() => {
                    router.go(-1)
                })
            }
            if (this.channelCode == "intelligent") {
                this.rtcInstance.destroy();
                router.go(-1)
            }
            if (this.channelCode == "huawei") {
                this.rtcInstance.stopPhone([this.instanceCode]);
                router.go(-1)
            }
        }
    }
    // 剪切板
    sendInputClipper(value) {
        if (this.rtcInstance) {
            return new Promise((resolve, reject) => {
                if (this.channelCode == "baidu") {
                    try {
                        this.rtcInstance.sendInputClipper(value)
                        resolve()
                    } catch (error) {
                        reject(error)
                    }
                }
                if (this.channelCode == "intelligent") {
                    try {
                        this.rtcInstance.sendInClipper(value)
                        resolve()
                    } catch (error) {
                        reject(error)
                    }
                }
                if (this.channelCode == "huawei") {
                    try {
                        this.rtcInstance.sendInputString(value)
                        resolve()
                    } catch (error) {
                        reject(error)
                    }
                }

            })
        }
    }
    // 摇一摇
    shakeCloudPhone() {
        if (this.rtcInstance) {
            if (this.channelCode == "baidu") {

            }
            if (this.channelCode == "intelligent") {

            }
            if (this.channelCode == "huawei") {
                this.rtcInstance.sendShakeData([this.instanceCode], sendShakeDataFun());
                setTimeout(() => {
                    this.rtcInstance.sendShakeData([this.instanceCode], sendShakeDataFun());
                }, 500);
            }
        }
    }
    // 容器大小变化，手动同步推流画面大小
    resizeShowVideo() {
        if (this.rtcInstance) {
            if (this.channelCode == "baidu") {
                setTimeout(() => {
                    redfinger.resizePhone();
                }, 1);
            }
            if (this.channelCode == "intelligent") {
                setTimeout(() => {
                    this.rtcInstance.nzSdkIns._resizeShowVideo();
                }, 1);
            }
        }
    }
    // 截图
    printscreenCloudPhone(url, fileName) {
        downloadImageCrossPlatform(url, fileName);
    }
}
export default ArmcloudEngine